import * as React from 'react';
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { IMtaState } from '../../../../../../../../services/mta/models';
import { MTACardHeader } from '../../../CoverDetails/scenes/Components/MTACardHeader';
import { addYears, differenceInDays, differenceInYears } from 'date-fns';

interface ICancelHeaderProps {
  title: string,
  mta: IMtaState,
  showText?: boolean,
  hideCustomerText?: boolean,
  icon?: string
  showDefaqto?: boolean
}

const CancelHeader = ({
                        title,
                        mta,
                        showText = true,
                        hideCustomerText = false,
                        icon = '',
                        showDefaqto = true
                      }: ICancelHeaderProps) => {

  const showAMTText = (mta.policyInfo?.meta?.termNumber ?? 1) > 1 && mta.policyInfo?.meta?.schemeType === 'annual';
  let firstPolicyStartDate = new Date(get(mta, 'policyInfo.meta.customer.firstPolicyStartDate'));
  const todayDate = new Date();

  const years = differenceInYears(todayDate, firstPolicyStartDate)
  const isPluralYears = years !== 1
  firstPolicyStartDate = addYears(firstPolicyStartDate, years)
  const days = differenceInDays(todayDate, firstPolicyStartDate)
  const isPluralDays = days !== 1
  const showBody = showText || (showAMTText && !hideCustomerText);

  return (
    <div className={'cancel-header-container'}>
      <MTACardHeader text={title} showDefaqto={showDefaqto} cancel={true} icon={icon}/>
      <div className={showBody ? 'cancel-h-body' : ''}>
        {showAMTText && !hideCustomerText && (
          <p>Plus you've been a customer with us for {years} {isPluralYears ? 'years' : 'year'} and {days} {isPluralDays ? 'days' : 'day'}!</p>
        )}
      </div>
    </div>
  )
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        mta: state.mta,
      };
    },
  ),
])(CancelHeader);
